<div class="container-fluid">

  <!-- ⭐ القسم الأصلي - استيراد من جهاز البصمة -->
  <div class="filter-form">
    <div class="row">
      <div class="col-md-3">
        <label>من تاريخ</label>
        <dx-date-box
          [(value)]="formData.fromDate"
          displayFormat="dd/MM/yyyy">
        </dx-date-box>
      </div>
       <div class="col-md-3">
        <label>الي تاريخ</label>
        <dx-date-box
          [(value)]="formData.toDate"
          displayFormat="dd/MM/yyyy">
        </dx-date-box>
      </div>

      <div class="col-md-3">
        <label>جهاز البصمة</label>
        <dx-select-box [showClearButton]="true"
          [(value)]="formData.printDeviceId"
          [dataSource]="devices"
          displayExpr="name"
          valueExpr="id">
        </dx-select-box>
      </div>

      <div class="col-md-3 d-flex align-items-end">
        <dx-button
          text="استيراد من جهاز البصمة"
          type="success"
          width="100%"
          (onClick)="onFormSubmit()">
        </dx-button>
      </div>
    </div>
  </div>

  <!-- ⭐ Separator -->
  <div style="height: 2px; background: linear-gradient(to right, #5cb85c,  #aef5ae); margin: 30px 0;">
  </div>

  <!-- ⭐ Bulk Upload Section من Excel -->


  <!-- ⭐ زرار الحفظ (للبيانات من جهاز البصمة) -->
  <div class="row mt-3" *ngIf="attendingData.length > 0">
    <div class="col-md-12">
      <dx-button
        text="حفظ البيانات"
        type="default"
        icon="save"
        width="200px"
        (onClick)="saveAttendanceData()"
        [disabled]="isSaving">
      </dx-button>
    </div>
  </div>

  <!-- ⭐ DataGrid الأصلي -->
  <dx-data-grid
    [dataSource]="attendingData"
    [showBorders]="true"
    [rtlEnabled]="true"
    [columnAutoWidth]="false" 
    [allowColumnResizing]="true"
    columnResizingMode="widget"> <dxo-scrolling mode="virtual" useNative="true" showScrollbar="always"></dxo-scrolling>
  <dxo-export [enabled]="true" [allowExportSelectedData]="true"></dxo-export> 
    <dxo-paging [pageSize]="10"></dxo-paging>
    
    <dxi-column dataField="employeeIdfromEmployyeTable" caption="كود الموظف" [width]="120"></dxi-column>
    <dxi-column dataField="employeeId" caption="كود بصمة الموظف" [width]="150"></dxi-column>
    <dxi-column dataField="employeeName" caption="اسم الموظف" [width]="250"></dxi-column>
    <dxi-column dataField="dateOfDay" caption="التاريخ" dataType="date" [width]="150"></dxi-column>
    <dxi-column dataField="workDurationSystemName" caption="فترة الحضور" [width]="200"></dxi-column>
    <dxi-column dataField="employeeDurationStartTime" caption="موعد بدء العمل" [width]="150"></dxi-column>
    <dxi-column dataField="timeAttending" caption="وقت الحضور" [calculateCellValue]="timeAttendingCell" [width]="150"></dxi-column>
    <dxi-column dataField="attendanceEarly" caption="زمن الحضور مبكرا" [width]="150"></dxi-column>
    <dxi-column dataField="attendanceLate" caption="زمن التاخير" [width]="120"></dxi-column>
    <dxi-column dataField="employeeDurationEndTime" caption="موعد نهاية العمل" [width]="150"></dxi-column>
    <dxi-column dataField="timeLeave" caption="وقت الانصراف" [calculateCellValue]="timeLeaveCell" [width]="150"></dxi-column>
    <dxi-column dataField="leaveEarly" caption="زمن الانصراف مبكرا" [width]="150"></dxi-column>
    <dxi-column dataField="leaveAfterTime" caption="زمن اضافي التاخير" [width]="150"></dxi-column>

</dx-data-grid>

</div>